import { GsapSnap } from "./gsap-snap";
import { ready } from "./utils";
import "multiple-select-vanilla/dist/browser/multiple-select.js";
import headerInit from "./header";
import playVideoBtn from "./video";
import { clixsySliders } from "./sliders";
import { gravityFormsLogic } from "./gravity-form-logic";
import { anchorScrolling } from "./js-anchor-scrolling";
import flipCardsMobile from "./additional";
import { showMore, loadMoreReview } from "./show-more";
import { accordionFAQ } from "./accordion";
import { eventsFilter } from "./events-filter";

ready(() => {
  headerInit();
  playVideoBtn();
  clixsySliders();
  GsapSnap();
  gravityFormsLogic();
  anchorScrolling();
  flipCardsMobile();
  showMore();
  loadMoreReview();
  accordionFAQ();
  accordionFAQ(
    '.custom-solutions-item',
    '.custom-solutions-item-header',
    '.custom-solutions-item-content'
  );
  eventsFilter();
});
